<template>
  <div class="tm-history">

    <!--поиск + фильтрация + описание-->
    <div class="uk-grid" data-uk-grid>

      <!--поиск + фильтрация-->
      <div :class="currentTab != 'ordersEducation' ? 'uk-width-1-3@l uk-width-1-2': 'uk-width-1-2'">
        <!--поиск и выбор кол-ва заказов на страницу-->
        <div class="uk-margin">
          <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
            <!--поиск по полю номера заказа-->
            <div class="uk-width-expand">
              <div class="uk-inline uk-width-1-1">
                <button type="button" class="uk-form-icon uk-form-icon-flip uk-icon" @click="clearSearchField">
                  <md-icon>clear</md-icon>
                </button>
                <input
                    class="uk-input"
                    :placeholder="local_page_keys.placeholder_for_search_order_number"
                    v-model="searchByOrderNumber"
                    @input="checkmethod" />
              </div>
            </div>
            <!--кол-во заказов в списке-->
            <div>
              <select class="uk-select"
                      v-model="pagination.perPage"
                      name="perPage"
                      ref="perPage"
                      id="perPage"
                      v-on:change="changeListLength">
                <template v-for="item in pagination.perPageOptions">
                  <option :label="item"
                          :value="item"
                          :key="item">
                    {{ item }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>

        <!--сортировка для всех табов, кроме ВСЕ ЗАКАЗА -->
        <div class="uk-margin" v-if="tab !== 0  && tab !== 9  && currentTab != 'ordersEducation'">
          <div class="uk-width-expand uk-position-relative uk-position-z-index">
            <div class="uk-grid uk-grid-small uk-grid-collapse_ uk-flex-middle uk-child-width-1-1 1" data-uk-grid>
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--выбор даты-->
                  <div class="uk-width-expand">
                    <div style="line-height: 1.2">
                      {{ local_page_keys.title_get_selected_period }}
                    </div>
                    <div class="uk-margin-small-top">
                      <DatepickerDialog
                          :dateTimePeriod=dateTimePeriod
                          :choosenPeriod.sync=choosenPeriod
                          :getPeriod=getPeriod
                          :todayDate=todayDate></DatepickerDialog>
                    </div>
                  </div>
                  <!--кнопка ПОКАЗАТЬ-->
                  <div v-if="dateTimePeriod !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                    {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                  <div v-if="sorted_mode !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table" @click="$emit('cancel_all_sort', currentTab)" data-uk-tooltip="Сбросить фильтрацию">
                      <md-icon>clear</md-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if=" currentTab === 'ordersEducation'">
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <div v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                    <v-select id="usersSelect"
                              :options="formattedUserForHistory"
                              label="text"
                              name="usersSelect"
                              ref="usersSelect"
                              multiple
                              v-model="chosenUsers"
                              :reduce="_function => _function.value"
                              :clearable="true"
                              class="tm-v-select"
                              placeholder="--">
                      <template #search="{attributes, events}">
                        <input
                            class="vs__search"
                            v-bind="attributes"
                            v-on="events"/>
                      </template>
                    </v-select>
                  </div>
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="currentTab !== 'regularCustomers'">
                <select class="uk-select"
                        v-model="selectSortOptionEducation"
                        name="selectSortOptionEducation"
                        ref="selectSortOptionEducation"
                        id="selectSortOptionEducation"
                        placeholder="--"
                        v-on:change="selectSortOptionEducationAction">
                  <option v-for="option of options_for_select_sort_for_orders_education_tab"
                          :value="option.value"
                          :key="option.id">
                    {{ local_page_keys[option.text] }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!--сортировка для ordersEducation -->
        <div class="uk-margin" v-if="currentTab === 'ordersEducation'">
          <div class="uk-width-expand uk-position-relative uk-position-z-index">
            <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
              <!--даты-->
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--выбор даты-->
                  <div class="uk-width-expand">
                    <div style="line-height: 1.2">
                      {{ local_page_keys.title_get_selected_period }}
                    </div>
                    <div class="uk-margin-small-top">
                      <DatepickerDialog
                          :dateTimePeriod=dateTimePeriod
                          :choosenPeriod.sync=choosenPeriod
                          :getPeriod=getPeriod
                          :todayDate=todayDate></DatepickerDialog>
                    </div>
                  </div>
                  <!--кнопка ПОКАЗАТЬ-->
                  <div v-if="dateTimePeriod !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                    {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                  <div v-if="sorted_mode !== ''">
                    <button class="uk-button uk-button-success tm-button-schedule-table" @click="$emit('cancel_all_sort', currentTab)" data-uk-tooltip="Сбросить фильтрацию">
                      <md-icon>clear</md-icon>
                    </button>
                  </div>
                </div>
              </div>
              <!--работник-->
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-auto" data-uk-grid>
                  <!--список-->
                  <div class="uk-width-expand" v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                    <div style="line-height: 1.2">
                      Выбор работника
                    </div>
                    <div class="uk-margin-small-top">
                      <v-select id="usersSelect"
                                :options="formattedUserForHistory"
                                label="text"
                                name="usersSelect"
                                ref="usersSelect"
                                multiple
                                v-model="chosenUsers"
                                :reduce="_function => _function.value"
                                :clearable="true"
                                class="tm-v-select"
                                placeholder="Выберите ретушера">
                        <template #search="{attributes, events}">
                          <input
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"/>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <!--кнопка-->
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            @click="getOrdersHistoryByPeriod"
                            style="color: #fff !important;">
                      <!--                      {{ local_page_keys.lable_button_show_order_period }}-->
                      <md-icon>arrow_forward_ios</md-icon>
                      <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                    </button>
                  </div>
                </div>
              </div>
              <!--фильтр по статусу-->
              <div>
                <div style="line-height: 1.2">
                  Выбор статуса
                </div>
                <div class="uk-margin-small-top">
                  <select class="uk-select"
                          v-model="selectSortOptionEducation"
                          name="selectSortOptionEducation"
                          ref="selectSortOptionEducation"
                          id="selectSortOptionEducation"
                          placeholder="--"
                          v-on:change="selectSortOptionEducationAction">
                    <option v-for="option of options_for_select_sort_for_orders_education_tab"
                            :value="option.value"
                            :key="option.id">
                      {{ local_page_keys[option.text] }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--сортировка для таба ВСЕ ЗАКАЗА -->
        <div class="uk-margin" v-if="tab === 0 && currentTab != 'ordersEducation'">
          <div class="uk-grid uk-grid-small uk-flex-bottom" data-uk-grid>
            <!--сортировка-->
            <div class="uk-width-expand">
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <!--Сортировать историю заказов по-->
                <div class="uk-width-1-1">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div style="line-height: 1.3">
                      {{ local_page_keys.title_table_select_option_for_sort }}
                    </div>
                    <div class="uk-margin-small-top">
                      <select class="uk-select"
                              v-model="selectSortOption"
                              name="selectSortOption"
                              ref="selectSortOption"
                              id="selectSortOption"
                              placeholder="--"
                              v-on:change="clearSelectedOptions">
                        <option value="" disabled selected hidden>--</option>
                        <option v-for="option of options_for_select_sort_for_orders_tab"
                                :value="option.value"
                                :key="option.id">
                          {{ local_page_keys[option.text] }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!--если "Периоду создания/обновления заказа"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'create_update_period'">
                  <div>
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                      <div>
                        <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                          <!--списки-->
                          <div class="uk-width-expand">
                            <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                              <!--datepicker-dialog-->
                              <div class="uk-animation-fade uk-animation-fast">
                                <div style="line-height: 1.2">{{ local_page_keys.title_get_selected_period }}</div>
                                <div class="uk-margin-small-top">
                                  <DatepickerDialog
                                      :dateTimePeriod = dateTimePeriod
                                      :choosenPeriod.sync=choosenPeriod
                                      :getPeriod = getPeriod
                                      :todayDate = todayDate></DatepickerDialog>
                                </div>
                              </div>
                              <!--list-->
                              <div v-if="choosenPeriod.length > 1">
                                <div style="line-height: 1.2">{{ local_page_keys.lable_get_selected_period_with_field }}</div>
                                <div class="uk-margin-small-top">
                                  <select class="uk-select"
                                          v-model="selectedDateField"
                                          name="selectedDateField"
                                          ref="selectedDateField"
                                          id="selectedDateField">
                                    <option value="" disabled selected hidden>--</option>
                                    <option :value="'created_at'">{{ local_page_keys.table_header_created_at }}</option>
                                    <option :value="'updated_at'">{{ local_page_keys.table_header_updated_at }}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--кнопка ПОКАЗАТЬ-->
                          <div class="uk-width-auto" v-if="selectedDateField !== ''">
                            <button class="uk-button uk-button-success tm-button-schedule-table" @click="getOrdersHistoryByPeriod" style="color: #fff !important;">
                              <!--                              {{ local_page_keys.lable_button_show_order_period }}-->
                              <md-icon>arrow_forward_ios</md-icon>
                              <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--если "Работе ретушеров/про-ретушеров"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'worker'">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div>
                      <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                        <!--списки-->
                        <div class="uk-width-expand">
                          <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                            <!--datepicker-dialog-->
                            <div>
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <DatepickerDialog
                                    :dateTimePeriod = dateTimePeriod
                                    :choosenPeriod.sync=choosenPeriod
                                    :getPeriod = getPeriod
                                    :todayDate = todayDate></DatepickerDialog>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="choosenPeriod.length > 1">
                              <div style="line-height: 1.3">
                                {{ local_page_keys.lable_role_select }}
                              </div>
                              <div class="uk-margin-small-top">
                                <select class="uk-select"
                                        v-model="choosenRole"
                                        name="choosenRole"
                                        ref="choosenRole"
                                        id="choosenRoleNew"
                                        v-on:change="showUserSelect">
                                  <option value="" disabled selected hidden>--</option>
                                  <option v-for="option in roles"
                                          :key="option.value"
                                          :value="option.value"
                                          v-text="option.text">
                                  </option>
                                </select>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                              <v-select id="usersSelect"
                                        :options="formattedUserForHistory"
                                        label="text"
                                        name="usersSelect"
                                        ref="usersSelect"
                                        multiple
                                        v-model="chosenUsers"
                                        :reduce="_function => _function.value"
                                        :clearable="true"
                                        class="tm-v-select"
                                        placeholder="--">
                                <template #search="{attributes, events}">
                                  <input
                                      class="vs__search"
                                      v-bind="attributes"
                                      v-on="events"/>
                                </template>
                              </v-select>
                            </div>
                          </div>
                        </div>
                        <!--кнопка ПОКАЗАТЬ-->
                        <div class="uk-width-auto" v-if="showShowWorkerButton">
                          <button class="uk-button uk-button-success tm-button-schedule-table"
                                  @click="getWorkerPeriodInfo"
                                  style="color: #fff !important;">
                            <!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                            <md-icon>arrow_forward_ios</md-icon>
                            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--если "Статусу заказа"-->
                <div class="uk-width-1-1 uk-position-relative uk-position-z-index" v-if="selectSortOption === 'status'">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1" data-uk-grid>
                    <div>
                      <div class="uk-grid uk-grid-small uk-flex-bottom uk-child-width-1-1" data-uk-grid>
                        <!--списки-->
                        <div class="uk-width-expand">
                          <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                            <!--datepicker-dialog-->
                            <div>
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <DatepickerDialog
                                    :dateTimePeriod = dateTimePeriod
                                    :choosenPeriod.sync=choosenPeriod
                                    :getPeriod = getPeriod
                                    :todayDate = todayDate></DatepickerDialog>
                              </div>
                            </div>
                            <!--list-->
                            <div v-if="choosenPeriod.length > 1">
                              <div style="line-height: 1.3">
                                {{ local_page_keys.title_sort_by_worker }}
                              </div>
                              <div class="uk-margin-small-top">
                                <v-select id="choosenStatus"
                                          :options="formattedStatuses"
                                          label="text"
                                          name="choosenStatus"
                                          ref="choosenStatus"
                                          multiple
                                          v-model="choosenStatus"
                                          :reduce="_function => _function.value"
                                          :clearable="true"
                                          class="tm-v-select"
                                          placeholder="--">
                                  <template #search="{attributes, events}">
                                    <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"/>
                                  </template>
                                </v-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--кнопка ПОКАЗАТЬ-->
                        <div class="uk-width-auto" v-if="showStatusButton">
                          <button class="uk-button uk-button-success tm-button-schedule-table"
                                  @click="getSortByStatus"
                                  style="color: #fff !important;">
                            <!--                            {{ local_page_keys.lable_button_show_order_period }}-->
                            <md-icon>arrow_forward_ios</md-icon>
                            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--сброс сортировки-->
            <div class="uk-width-auto" v-if="sorted_mode !== ''">
              <button class="uk-button uk-button-success tm-button-schedule-table"
                      @click="$emit('cancel_all_sort', true)"
                      data-uk-tooltip="Сбросить фильтрацию">
                <md-icon>clear</md-icon>
              </button>
            </div>
          </div>
        </div>
        <label v-if="currentTab !== 'ordersUnviewed'">
          <input type="checkbox"
                 :checked="searchInArchive[currentTab]"
                 @input="archiveChecker"
                 class="uk-checkbox">
          Поиск по архиву
        </label>
      </div>

      <!--описание-->
      <div v-if="tab !== 0 && tab !== 6 && currentTab !== 'regularCustomers' && currentTab !== 'ordersUnviewed'" class="uk-width-expand">
        <div class="uk-padding-small uk-background-muted">
          <div class="uk-grid uk-grid-small uk-child-width-expand" data-uk-grid>
            <div class="uk-width-auto">
              <md-icon style="color: rgb(76, 175, 80)">info</md-icon>
            </div>
            <!--            <div v-if="currentTab === 'ordersAll'">-->
            <!--              1 таб ordersAll-->
            <!--            </div>-->
            <!--ordersDone-->
            <div v-if="tab === 1">
              <div class="uk-text-bold">Готовы</div>
              <div class="uk-margin-top">Координатор: Необходима ежедневная проверка выполненых заказов за предыдуший день (несколько дней) для анализа самых медленных в выполении заказов.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавление сортировки по столбцу “От активности клиента“</li>
                <li>3. Рассматриваем и анализируем причину, почему так долго были заказы в работе</li>
                <li>4. Находим тех баги и отправляем их в тех отдел, орг проблемы рассматриваем с проверяющими-ретушерами индивидуально</li>
              </ul>
            </div>
            <!--ordersInWork-->
            <div v-else-if="tab === 2">
              <div class="uk-text-bold">В работе</div>
              <div class="uk-margin-top">Координатор:  Необходима проверка самых долговыполняемых заказов 1 раз в 2 часа для отлова ошибок.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Добавление сортировки по столбцу “От активности клиента“</li>
                <li>2. Рассматриваем и анализируем причину, почему так долго были заказы в работе</li>
                <li>3. Находим тех баги и отправляем их в тех отдел, орг проблемы рассматриваем с проверяющими-ретушерами индивидуально</li>
              </ul>
            </div>
            <!--rejectByAdmin-->
            <div v-else-if="tab === 3">
              <div class="uk-text-bold">Отклонено проверяющим</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины отказов проверяющих.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Прорабатывайте причины отказа от заказа у проверяющих</li>
                <li>3. При необходимости проработать ошибочно отклоненные с проверяющим</li>
              </ul>
            </div>
            <!--rejectByRetoucher-->
            <div v-else-if="tab === 4">
              <div class="uk-text-bold">Отклонено ретушером</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины отказов ретушеров.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавьте сортировку по уменьшению поля "Отклонено ретушером"</li>
                <li>3. Прорабатывайте причины отказа от заказа у ретушеров</li>
                <li>4. При необходимости давать ретушеру на проработку ту опцию, которую он не смог/отказался выполнить в этот раз</li>
              </ul>
            </div>
            <!--firstAndSecond-->
            <div v-else-if="tab === 5">
              <div class="uk-text-bold">1 и 2й заказы</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная точечная проверка 15 заказов на предмет целесообразности и актуальности назначения дополнительных функций.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов;</li>
                <li>2. Добавьте сортировку по уменьшению поля "Добавлены функции"</li>
                <li>3. Проверьте около 5 заказов, в которые добавили 3+ функций</li>
                <li>4. Проверьте около 5 заказов, в которые добавили 1-2 функции</li>
                <li>5. Проверьте около 5 заказов, в которые не было назначено дополнительных функций</li>
                <li>6. Сформируйте отчет в телеграме с информацией - номер заказа и краткий комментарий для дальнейшего пересмотра ошибок в этом разделе</li>
                <li>7. При возникновении сомнений, обсудите с Наташей, если все однозначно - проведите работу над ошибками с проверяющими</li>
              </ul>
            </div>
            <!--ordersDoneSenior-->
            <!--            <div v-else-if="tab === 6">-->
            <!--              7 таб ordersDoneSenior-->
            <!--            </div>-->
            <!--ordersForcedClosed-->
            <div v-else-if="tab === 7">
              <div class="uk-text-bold">Принудительно закрытые</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет понимания причины закрытия заказов проверяющим.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Прорабатывайте причины закрытия заказа у проверяющих</li>
                <li>3. При необходимости проработать ошибочно закрытые с проверяющим</li>
              </ul>
            </div>
            <!--returnRetouchers-->
            <div v-else-if="currentTab === 'returnRetouchers'">
              <div class="uk-text-bold">Возврат ретушерам</div>
              <div class="uk-margin-top">Сеньор админ: Необходима ежедневная проверка заказов на предмет адекватности работы админов и коррекции навыков ретушеров.</div>
              <ul class="uk-list uk-margin-top">
                <li>1. Выберите предыдущий неразобранный период заказов</li>
                <li>2. Добавьте сортировку по уменьшению поля "Всего переделок"</li>
                <li>3. Прорабатывайте причины переделок заказа у ретушеров</li>
                <li>4. При необходимости давать ретушеру на проработку ту опцию, которую он не смог/отказался выполнить в этот раз</li>
                <li>5. При необходимости проработайте с админами формулировки/адекватность написания комментариев</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--список-->
    <div class="uk-grid-collapse uk-grid uk-child-width-1-1 uk-grid-divider tm-history-grid" data-uk-grid>
      <template v-if="loading">
        <div>
          <div class="uk-padding-xsmall">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"></v-progress-circular>
          </div>
        </div>
      </template>
      <template v-else>
        <!--НОВЫЙ ВИД-->
        <div>
          <div class="uk-grid uk-grid-small uk-flex-bottom uk-margin-top" data-uk-grid>
            <div v-for="order of tableList" :key="order.id">
              <a :href="'#' + order.order_id"
                 @click="$emit('openOrder', { orderId: order.order_id, currentTab:currentTab, tabList:tableList })"
                 class="tm-link-visited uk-link-reset">
                <div class="uk-box-shadow-small uk-box-shadow-hover-medium tm-order-grid-box">
                  <!--фото-->
                  <div class="tm-order-grid-imgs uk-background-muted uk-flex uk-flex-center uk-flex-column uk-flex-middle uk-position-relative uk-text-center uk-transition-toggle">
                    <img :src="order.order_photo_before_url_thumb" alt="before">
                    <img v-if="order.order_photo_after_url_ver_last_thumb" class="uk-transition-fade uk-position-center" :src="order.order_photo_after_url_ver_last_thumb" alt="after">
                  </div>
                  <!--инфо блок-->
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid tm-grid-xsmall uk-flex-middle uk-flex-center" data-uk-grid>
                      <!--версия при наведении: B - весрия before, V1 - буква V и номер версии-->
                      <div>
                        <div class="tm-how-much-orders" v-if="order.last_version">
                          <span class="before-hover">B</span>
                          <span class="on-hover" :data-uk-tooltip="'pos: top; title: V' + order.last_version">V{{ order.last_version }}</span>
                        </div>
                        <div class="tm-how-much-orders" v-else>
                          B
                        </div>
                      </div>
                      <!--1 или 2 заказ-->
                      <div>
                        <div class="tm-how-much-orders" style="color: #9c27b0;border-color: #9c27b0;border-radius: 0;" :data-uk-tooltip="'pos: top; title: ' + order.count_order + ' заказ'">
                          {{order.count_order}}
                        </div>
                      </div>
                      <!--Значек статуса клиента, выводим если есть-->
                      <div v-if="getStatusClient(order).href">
                        <img :src="getStatusClient(order).href" width="30" height="30" alt="" :data-uk-tooltip="getStatusClient(order).tooltip" class="tm-img-icon">
                      </div>
                      <!--просмотры заказа клиентом последней версии-->
                      <div v-if="order.last_version_view === 1">
                        <div data-uk-tooltip="pos: top; title: Последняя версия заказ была просмотрена клиентом">
                          <md-icon>visibility</md-icon>
                        </div>
                      </div>
                      <!--Список функций-->
                      <div>
                        <div :data-uk-tooltip="'pos: top; title:' + getTooltipFunction(order.functions)">
                          <md-icon class="uk-text-success">settings_suggest</md-icon>
                        </div>
                      </div>
                      <!--info-->
                      <div>
                        <div :data-uk-tooltip="'pos: top; title:' + getToolTipInfo(order)">
                          <md-icon class="uk-text-warning">info</md-icon>
                        </div>
                      </div>
                      <!--rejected_admin-->
                      <div v-if="order.status === 'rejected-admin'" data-uk-tooltip="pos: top; title: Заказ был отклонен про-ретушером">
                        <md-icon class="tm-senior-mark-ico tm-icon-close">close</md-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!--пагинация-->
    <template v-if="paginated.total_entries !== 0">
      <hr class="uk-margin-medium-bottom">
      <div class="uk-grid uk-flex-middle" data-uk-grid v-if="showpagination">
        <div class="uk-width-expand">
          {{ paginated.from_entries }}-{{ paginated.to_entries }} {{ local_page_keys.pagination_lable_of }} {{ paginated.total_entries }} {{ local_page_keys.pagination_entries }}
        </div>
        <div>
          <ul class="uk-pagination tm-pagination uk-flex-center uk-flex-middle">
            <li :class="(pagination.currentPage === 1 ? 'uk-disable' : '')">
              <button type="button"
                      class="uk-link-reset"
                      @click="goToPrevious()"
                      :disabled="pagination.currentPage === 1">
                <span data-uk-pagination-previous></span>
              </button>
            </li>
            <li class="uk-active"><span>{{ currentPage }}</span></li>
            <li>
              <input class="uk-input" style="width: 40px;margin: 0 5px;" data-uk-tooltip="Переход на страницу" v-model="pageNumber" @input="goToPage()">
            </li>
            <li>
              page of {{ paginated.total_page }}
            </li>
            <li :class="(pagination.currentPage >= pagination.totalPages ? 'uk-disable' : '')">
              <button type="button"
                      class="uk-link-reset"
                      @click="goToNext()"
                      :disabled="pagination.currentPage === paginated.last_page">
                <span data-uk-pagination-next></span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="uk-text-center uk-padding">
        результаты не найдены
      </div>
    </template>
  </div>
</template>

<script>
import filter_table_admin_orders_history from "../../../filters/filter_table_admin_orders_history";
import DatepickerDialog from "./Admin/DatepickerDialog.vue";

export default {
  name: "AdminOrderHistoryTable",
  components: {DatepickerDialog},
  filters: {filter_table_admin_orders_history},
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    ordersHistoryList: {
      type: Object,
      require: true,
    },
    headers: {
      type: Array,
      require: true
    },
    tab: {
      require: true
    },
    tabs: {
      type: Array,
      require: true
    },
    showForClient: {
      type: String,
      require: true
    },
    searchInArchive: {
      type: Object,
      require: true
    }
  },
  data: () => ({
    paginated: {
      last_page: 1,
      from_entries: 1,
      to_entries: 1,
      total_entries: 1,
      total_page: 1
    },
    pagination: {
      perPage: 60,
      currentPage: 1,
      perPageOptions: [60, 120],
    },
    changedList: [],
    sort_by: {
      column: 'created_at',
      order: 'desc'
    },
    showDateRangePiecker: false,
    choosenPeriod: [],
    choosenRole: '',
    roles: [
      {
        text: "pro-retouchers",
        value: "pro-retoucher"
      },
      {
        text: "retouchers",
        value: "retoucher"
      }
    ],
    statuses: [
      {
        text: "new_order",
        value: "new"
      },
      {
        text: "hold_retoucher",
        value: "hold-retoucher"
      },
      {
        text: "hold_admin",
        value: "hold-admin"
      },
      {
        text: "re_done_customer",
        value: "re-done-customer"
      },
      {
        text: "rejected_admin_to_retoucher",
        value: "rejected-admin-to-retoucher"
      },
      {
        text: "re_done_admin",
        value: "re-done-admin"
      },
      {
        text: "done_retoucher",
        value: "done-retoucher"
      },
      {
        text: "rejected_retoucher",
        value: "rejected-retoucher"
      },
      {
        text: "broken",
        value: "broken"
      },
      {
        text: "rejected_admin",
        value: "rejected-admin"
      },
      {
        text: "done_admin",
        value: "done-admin"
      }
    ],
    choosenStatus: [],
    todayDate: '',
    selectedDateField: '',
    options_for_select_sort_for_orders_tab: [
      {value: 'create_update_period', text: 'select_option_for_sort_by_create_update_period'},
      {value: 'worker', text: 'select_option_for_sort_by_worker'},
      {value: 'status', text: 'select_option_for_sort_by_status'}
    ],
    options_for_select_sort_for_orders_education_tab: [
      {value: 'all', text: 'select_option_for_sort_by_worker_all'},
      {value: 'completed', text: 'select_option_for_sort_by_worker_completed'},
      {value: 'in_work', text: 'select_option_for_sort_by_worker_in_work'}
    ],
    options_for_select_sort_for_done_orders_tab: [
      {value: 'create_update_period', text: 'select_option_for_sort_by_create_update_period'},
      {value: 'worker', text: 'select_option_for_sort_by_worker'},
    ],
    selectSortOption: '',
    selectSortOptionEducation: 'all',
    chosenUsers: [],
    users_for_history: [],
    searchByOrderNumber: '',
    sorted_mode: '',
    showpagination: true,
    pageNumber: '',
    loading: false,
    showForClientInt: false,
    local_page_keys_functions: {},
  }),
  methods: {
    async goToPrevious() {
      this.pagination.currentPage--;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async goToNext() {
      this.pagination.currentPage++;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async goToPage() {
      this.pagination.currentPage = this.pageNumber;
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },

    async getOrdersHistoryList() {
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }

      let data;
      this.loading = true;
      this.changedList = [];
      this.showForClientInt = false;

      if (this.showForClient === '') {
        await this.$store.dispatch('adminOrdersHistory/tadOrdersList', params);
        data = await this.$store.getters['adminOrdersHistory/tadOrdersList'];
      } else {
        params['client_id'] = this.showForClient;
        this.showForClientInt = true;
        await this.$store.dispatch('adminOrdersHistory/tadOrdersListByClientId', params);
        data = await this.$store.getters['adminOrdersHistory/tadOrdersListByClientId'];
      }
      if (typeof data === 'object' && data.status === "success") {
        this.pagination.currentPage = data['orders'].current_page;
        this.pagination.perPage = data['orders'].per_page;
        this.paginated.from_entries = data['orders'].from;
        this.paginated.to_entries = data['orders'].to;
        this.paginated.last_page = data['orders'].last_page;
        this.paginated.total_entries = data['orders'].total;
        this.paginated.total_page = data['orders'].last_page;
        this.changedList = Object.values(data['orders'].data);

      } else {
        alert(data);
      }
      this.loading = false;
    },
    async onSortBy(data) {
      let column = data.column;
      let order = data.order;
      if (this.sort_by.column === column) {
        this.sort_by.order = order === 'desc' ? 'asc' : 'desc';
      } else {
        this.sort_by.column = column;
        this.sort_by.order = order;
      }
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }

    },
    getPeriod() {
      this.choosenPeriod.sort();
    },
    clearSelectedOptions() {
      this.selectedDateField = '';
      this.choosenPeriod = [];
      this.choosenRole = '';
      this.chosenUsers = [];
    },
    selectSortOptionEducationAction(){
      this.getOrdersHistoryByPeriod();
    },
    async showUserSelect() {
      this.users_for_history = [];
      this.chosenUsers = [];
      try {
        let roles = [this.choosenRole];
        await this.$store.dispatch("users/chosenRolesUsersList", {roles});
        this.users_for_history = await this.$store.getters['users/chosenRolesUsersList'];
      } catch (e) {
        alert(this.local_page_keys.alert_something_went_wrong)
      }
    },
    async getSearchByOrderNumber() {
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        order_number: this.searchByOrderNumber,
        archive: this.searchInArchive[this.currentTab]
      }
      this.loading = true;
      if (this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        if (this.showForClient !== '') params['client_id'] = this.showForClient;
        await this.$store.dispatch('adminOrdersHistory/tabSearchOrdersList', params)
        let data = await this.$store.getters['adminOrdersHistory/tabSearchOrdersList'];
        if (typeof data === 'object' && data.status === "success") {
          this.changedList = [];
          this.pagination.currentPage = data['orders'].current_page;
          this.pagination.perPage = data['orders'].per_page;
          this.paginated.from_entries = data['orders'].from;
          this.paginated.to_entries = data['orders'].to;
          this.paginated.last_page = data['orders'].last_page;
          this.paginated.total_entries = data['orders'].total;
          this.paginated.total_page = data['orders'].last_page;
          this.changedList = Object.values(data['orders'].data);
        } else {
          alert(this.local_page_keys.alert_something_went_wrong);
        }
        this.loading = false;
      }
    },
    async changeListLength() {
      if (this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if (this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      } else if (this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if (this.sorted_mode === '' && this.searchByOrderNumber === '') {
        await this.getOrdersHistoryList();
      } else {
        await this.getSearchByOrderNumber();
      }
    },
    async getWorkerPeriodInfo() {
      let users = this.chosenUsers.filter((el)=> {return el !=='';})
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        user_ids: users,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/workersTabPeriod', params);
      let data = await this.$store.getters['adminOrdersHistory/workersTabPeriod'];
      this.sorted_mode = 'workers_period';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data[this.currentTab].current_page;
        this.pagination.perPage = data[this.currentTab].per_page;
        this.paginated.from_entries = data[this.currentTab].from;
        this.paginated.to_entries = data[this.currentTab].to;
        this.paginated.last_page = data[this.currentTab].last_page;
        this.paginated.total_entries = data[this.currentTab].total;
        this.paginated.total_page = data[this.currentTab].last_page;
        this.changedList = data[this.currentTab].data;
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;
    },
    async getOrdersHistoryByPeriod() {
      let users = this.chosenUsers.filter((el)=> {return el !=='';})

      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        field: this.selectedDateField,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        selectSortOptionEducation: this.selectSortOptionEducation,
        archive: this.searchInArchive[this.currentTab]
      }
      if(users.length > 0){
        params['user_ids'] = users;
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      if(this.currentTab == 'ordersEducation'){
        params['page'] = 1;
        this.pagination.currentPage = 1;
        this.pageNumber = 1;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/historyByPeriod', params);
      let data = await this.$store.getters['adminOrdersHistory/historyByPeriod'];
      this.sorted_mode = 'history_by_period';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data['orders'].current_page;
        this.pagination.perPage = data['orders'].per_page;
        this.paginated.from_entries = data['orders'].from;
        this.paginated.to_entries = data['orders'].to;
        this.paginated.last_page = data['orders'].last_page;
        this.paginated.total_entries = data['orders'].total;
        this.paginated.total_page = data['orders'].last_page;
        this.changedList = Object.values(data['orders'].data);
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;
    },
    async getSortByStatus() {
      if (this.choosenStatus.includes('broken')) {
        let broken_statuses = ['broken', 'broken_finances_at_creating', 'broken_finances_at_set_free_order_for_retoucher']
        for (let brok_status of broken_statuses) {
          this.choosenStatus.push(brok_status);
        }
      }
      let statuses = this.choosenStatus.reduce((prev, cur) => (prev.indexOf(cur) === -1) ? [...prev, cur] : prev, []);
      let params = {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        tab: this.currentTab,
        sort_by: this.sort_by,
        statuses: statuses,
        period: {
          date_start: this.choosenPeriod[0],
          date_end: this.choosenPeriod[1],
        },
        archive: this.searchInArchive[this.currentTab]
      }
      if (this.showForClient !== '') {
        params['client_id'] = this.showForClient;
      }
      if (this.searchByOrderNumber !== '') {
        params['order_number'] = this.searchByOrderNumber;
      }
      this.loading = true;
      await this.$store.dispatch('adminOrdersHistory/historyByStatuses', params);
      let data = this.$store.getters['adminOrdersHistory/historyByStatuses'];
      this.sorted_mode = 'history_by_statuses';
      if (typeof data === 'object' && data.status === "success") {
        this.changedList = [];
        this.pagination.currentPage = data[this.currentTab].current_page;
        this.pagination.perPage = data[this.currentTab].per_page;
        this.paginated.from_entries = data[this.currentTab].from;
        this.paginated.to_entries = data[this.currentTab].to;
        this.paginated.last_page = data[this.currentTab].last_page;
        this.paginated.total_entries = data[this.currentTab].total;
        this.paginated.total_page = data[this.currentTab].last_page;
        this.changedList = data[this.currentTab].data;
        this.showpagination = true;
      } else {
        this.showpagination = false;
        this.changedList = [];
        alert(data);
      }
      this.loading = false;

    },
    async checkmethod() {
      if (this.sorted_mode === '') {
        await this.getSearchByOrderNumber();
      } else if(this.sorted_mode === 'workers_period') {
        await this.getWorkerPeriodInfo();
      } else if(this.sorted_mode === 'history_by_period') {
        await this.getOrdersHistoryByPeriod();
      } else if(this.sorted_mode === 'history_by_statuses') {
        await this.getSortByStatus();
      }
    },
    clearSearchField() {
      this.searchByOrderNumber = '';
      this.getOrdersHistoryList();
    },
    toggleDateRangePicker() {
      this.showDateRangePicker = !this.showDateRangePicker;
    },
    async archiveChecker(event){
      this.$emit('update:search-in-archive', event.target.checked);
      //  await this.getOrdersHistoryList()
      await this.checkmethod();
    },
    getTooltipFunction(functions) {
      const parsedFunctions = JSON.parse(functions);
      const translations = this.local_page_keys_functions;
      if (parsedFunctions.length > 1 && typeof parsedFunctions[1] === 'object') {
        const functionKeys = Object.keys(parsedFunctions[1]);
        if (functionKeys.length > 0) {
          // Для каждого ключа ищем перевод. Если его нет, возвращаем сам ключ.
          const translatedKeys = functionKeys.map(key => translations[key] || key);
          return translatedKeys.join('<br>');
        }
      }
      return '';
    },
    getToolTipInfo(order) {
      return 'Номер заказа: ' + order.order_number + '</br>ID заказа: ' + order.order_id + '</br>Клиент: ' +  order.ID_client + '</br>Статус заказа: ' + order.status
          + '</br>Заказ создан: ' + order.created_at + '</br>Заказ обновлен: ' +  order.updated_at;
    },
    getStatusClient(order){
      let data = {
        'href': null,
        'tooltip': null
      }

      if (order.vip_location) {
        data.href = 'https://retoucher.app:10001/storage/icon/order_silver_super_function.svg'
        data.tooltip = 'Расширенная'
      } else if (order.replenishment_count) {
        data.href = 'https://retoucher.app:10001/storage/icon/order_super_function.svg'
        data.tooltip = 'Расширенная'
      } else if (order.subscription_count) {
        data.href = 'https://retoucher.app:10001/storage/icon/order_subscription_super_function.png'
        data.tooltip = 'Подписка'
      }

      return data;
    }

  },
  computed: {
    currentTab() {
      return this.tabs[this.tab].value;
    },
    tableList() {
      //return this.changedList.length === 0 && this.searchByOrderNumber === '' && this.sorted_mode === '' && this.showForClient === '' ? this.ordersHistoryList.data : this.changedList;
      return this.changedList.length === 0 && this.searchByOrderNumber === '' && this.sorted_mode === '' && !this.showForClientInt  ? this.ordersHistoryList.data : this.changedList;
    },
    currentPage() {
      return this.changedList.length > 0 ? this.pagination.currentPage : this.ordersHistoryList.current_page;
    },
    per_page() {
      return this.changedList.length > 0 ? this.pagination.perPage : this.ordersHistoryList.per_page;
    },
    dateTimePeriod() {
      return this.choosenPeriod.length > 0 ? this.choosenPeriod[0] + '~' + this.choosenPeriod[1] : '';
    },
    showShowWorkerButton() {
      return this.chosenUsers.length === 1 && this.chosenUsers.includes('') ? false : this.chosenUsers.length > 0;
    },
    showStatusButton() {
      return this.choosenStatus.length === 1 && this.choosenStatus.includes('') ? false : this.choosenStatus.length > 0;
    },
    formattedStatuses() {
      return this.statuses.map(status => ({
        value: status.value,
        text: this.local_page_keys[ 'option_select_status_' + status.text]
      }));
    },
    formattedUserForHistory() {
      const users = Object.values(this.users_for_history);
      return users.map(user => ({
        value: user.id,
        text: (user.name !== '' ? user.name : user.email) + '(' + user.email + ' ' + user.role + ')'
      }))
    },
    orderListGetTabClass() {
      if (this.currentTab === 'firstAndSecond') {
        return 'tm-child-width-1-12';
      } else if (this.currentTab === 'rejectByRetoucher') {
        return 'tm-child-width-1-12';
      } else if (this.currentTab === 'returnRetouchers') {
        return 'tm-child-width-1-10';
      } else if (this.currentTab === 'ordersInWork') {
        return 'tm-child-width-1-10';
      } else {
        return 'tm-child-width-1-11';
      }
    },
  },
  async created() {
    this.local_page_keys_functions = await this.$filtergetLocalisationPage('ru_retoucher_translations');
    let today = new Date().toJSON();
    this.todayDate = today.slice(0, today.indexOf('T'))
    this.pagination.currentPage = this.ordersHistoryList.current_page;
    this.pagination.perPage = this.ordersHistoryList.per_page;
    this.paginated.from_entries = this.ordersHistoryList.from;
    this.paginated.to_entries = this.ordersHistoryList.to;
    this.paginated.last_page = this.ordersHistoryList.last_page;
    this.paginated.total_entries = this.ordersHistoryList.total;
    this.paginated.total_page = this.ordersHistoryList.last_page;

    if (this.tab !== 0 ) {
      let currentDate = new Date();
      let formattedDateEnd = currentDate.getFullYear() + '-' + ((currentDate.getMonth() + 1) < 10 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
      let dateToWeek = new Date(); // Создаем новый объект Date для начальной даты
      dateToWeek.setDate(currentDate.getDate() - 1); // Устанавливаем начальную дату на неделю назад
      let formattedDateStart = dateToWeek.getFullYear() + '-' + ((dateToWeek.getMonth() + 1) < 10 ? '0' : '') + (dateToWeek.getMonth() + 1) + '-' + (dateToWeek.getDate() < 10 ? '0' : '') + dateToWeek.getDate();
      this.choosenPeriod.push(formattedDateStart, formattedDateEnd );
    }

  },
  mounted(){
    if(this.currentTab == 'ordersEducation'){
      this.choosenRole = 'retoucher';
      this.showUserSelect();
    }
  }
}
</script>
<style>
@import '../../../assets/css/uikit/list.css';
.tm-order-grid-box {
  display: block;
  background-color: #fff;
  border: 2px solid #ececec;
}
.tm-link-visited:focus .tm-order-grid-box,
.tm-link-visited:visited .tm-order-grid-box {
  border-color: #9c27b0;
  background-color: #ebebeb;
}
.tm-order-grid-imgs {
  height: 500px;
}
.tm-order-grid-imgs img {
  min-height: 500px;
  max-height: 500px;
  width: auto;
}
.tm-order-grid-imgs img.rotated {
  transform: rotate(90deg);
  transform-origin: center;
  max-width: 500px;
  min-height: auto;
}
.tm-history-grid-head,
.tm-history-grid {
  line-height: 1.2;
}
.tm-how-much-orders .before-hover {
  display: inline;
}

.tm-how-much-orders .on-hover {
  display: none;
}

.tm-order-grid-imgs:hover ~ .uk-padding-xsmall .tm-how-much-orders .before-hover {
  display: none;
}

.tm-order-grid-imgs:hover ~ .uk-padding-xsmall .tm-how-much-orders .on-hover {
  display: inline;
}

.tm-how-much-orders .on-hover {
  display: none;
}

.tm-how-much-orders:hover .before-hover {
  display: none;
}

.tm-how-much-orders:hover .on-hover {
  display: inline;
}
</style>